module.exports = __webpack_public_path__ + "assets/img/android-icon.d01b1115.png";